<template>
  <div>
    <tiptap-vuetify
      v-model="editorValue"
      :extensions="extensions"
      :placeholder="label || $t('emailDetails.body')"
      :rules="rules"
      :required="required"
      :disabled="readonly"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      @keydown="$emit('keyup')"
    />
    <div v-if="hint" class="tiptap-hint">
      {{ hint }}
    </div>
  </div>
</template>

<script>
import {
  TiptapVuetify,
  Bold,
  Italic,
  Underline,
  ListItem,
  BulletList,
  HardBreak
} from 'tiptap-vuetify';

export default {
  components: { TiptapVuetify },
  props: {
    value: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },

    hint: {
      type: String,
      default: ''
    },

    required: {
      type: Boolean,
      required: false,
      default: false
    },

    rules: {
      type: Array,
      required: false,
      default: () => ([])
    }
  },
  data: () => ({
    editorValue: '',
    extensions: [
      Bold,
      Italic,
      Underline,
      ListItem,
      BulletList,
      HardBreak
    ]
  }),

  mounted() {
    this.editorValue = this.value;
  },

  watch: {
    value(value) {
      this.editorValue = value;
    },

    editorValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style>
.tiptap-vuetify-editor--disabled .tiptap-vuetify-editor__toolbar {
  display: none;
}

.tiptap-vuetify-editor--disabled .v-card.v-sheet {
  box-shadow: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.tiptap-vuetify-editor__content {
  background-color: #fff;
  opacity: 1;
}

.tiptap-vuetify-editor__content--disabled {
  color: inherit;
}

.tiptap-vuetify-editor--disabled {
  cursor: inherit;
}

.tiptap-hint {
  font-size: 12px;
  padding: 0 12px;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
